import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const AiTextButton = ({ kind, context = "", onGenerated, testid, label = "Générer avec l'IA" }) => {
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const ctx = typeof context === "function" ? context() : context;
      const { data } = await api.post("/admin/ai/generate-text", { kind, context: ctx });
      onGenerated(data.text);
      toast.success("Proposition générée — modifiez-la puis enregistrez");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={run}
      disabled={loading}
      className="flex h-7 shrink-0 items-center gap-1.5 rounded-full border border-terracotta px-3 text-[9px] font-bold uppercase tracking-widest text-terracotta transition-colors hover:bg-terracotta hover:text-sand disabled:opacity-50"
    >
      {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : <Sparkles className="h-3 w-3" />}
      {loading ? "Rédaction…" : label}
    </button>
  );
};

export default AiTextButton;
